import { Table, TableBody, TableCell, TableHead, TableRow } from '@eversports/klimt-primitives/legacy/Table'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { Localized, useIntl } from '../../../../localization/react'
import type { PurchaseOption } from '../../ActivityDetails.types'

import PriceTableRow from './PriceTableRow'

interface Props {
  purchaseOptions: Array<PurchaseOption>
  isCorporateUser: boolean
}

const PriceTable = ({ purchaseOptions, isCorporateUser }: Props) => {
  const intl = useIntl()

  const tableContainsTickets = purchaseOptions.some((purchaseOption) => purchaseOption.__typename === 'Ticket')

  return (
    <Table
      sx={{ minWidth: 340 }}
      size="small"
      aria-label={
        tableContainsTickets ? intl.activityDetailTicketOptionsHeading() : intl.activityDetailPricingOptionsHeading()
      }
    >
      <TableHead sx={{ '> .MuiTableRow-root': { backgroundColor: 'white' } }}>
        <TableRow>
          <TableCell>
            <Text variant="label" color="midnight">
              <Localized id="activity-detail-product-table-product-price-header" />
            </Text>
          </TableCell>
          <TableCell>
            <Text variant="label" color="midnight">
              <Localized id="activity-detail-product-table-product-name-header" />
            </Text>
          </TableCell>
          <TableCell align="center">
            <Text variant="label" color="midnight">
              <Localized id="activity-detail-product-table-product-tags-header" />
            </Text>
          </TableCell>
          {tableContainsTickets && (
            <TableCell>
              <Text variant="label" color="midnight">
                <Localized id="activity-detail-product-table-additional-info-header" />
              </Text>
            </TableCell>
          )}
        </TableRow>
      </TableHead>
      <TableBody>
        {purchaseOptions.map((purchaseOption) => (
          <PriceTableRow key={purchaseOption.id} purchaseOption={purchaseOption} isCorporateUser={isCorporateUser} />
        ))}
      </TableBody>
    </Table>
  )
}

export default PriceTable
